import { createAction, props } from '@ngrx/store';
import { IServicio, ICreateServicio, IDeleteServicioResponse, IUpdateServicio, IUpdateServicioResponse } from '../../interfaces/servicios.interface';

export const GetServicios = createAction(
    '[Servicios] Get Servicios',
  );

export const GetServiciosSuccess = createAction(
    '[Servicios] Get Servicios Success',
    props<{servicios: IServicio[]}>()
  );

export const CreateServicio = createAction(
    '[Servicios] Create Servicios',
    props<{servicio: ICreateServicio}>()
  );

export const CreateServicioSuccess = createAction(
    '[Servicios] Create Servicios Success',
    props<{servicio: IServicio}>()
  );

export const DeleteServicio = createAction(
    '[Servicios] Delete Servicios',
    props<{id: string}>()
  );

export const DeleteServicioSuccess = createAction(
    '[Servicios] Delete Servicios Success',
    props<{servicio: IDeleteServicioResponse}>()
  );

export const UpdateServicio = createAction(
    '[Servicios] Update Servicios',
    props<{id: string, servicio: IUpdateServicio}>()
  );

export const UpdateServicioSuccess = createAction(
    '[Servicios] Update Servicios Success',
    props<{servicio: IUpdateServicioResponse}>()
  );
